import React, { useEffect, useMemo, useState } from 'react';

import { siteRegInputs } from './educationDataInputs';
import { prepareInput } from '~p/EventReg/Input';
import { Button } from '~c/ui/Button';
import { FormMessage } from '~c/FormMessage';
import { updateUserData } from './utils';

import messages from '~h/messages';
import metrikaGoal from '../../../../../helpers/metrikaGoal';

export const EducationData = (props) => {

  const {
    formType,
    studentData,
    canPay,
    studentId,
    lastname,
    firstname,
    dataForEduServices,
    setButtonDisabled
  } = props;

  const title = useMemo(() => (
    <h4 className="heading heading--2 heading--reverse">
      {lastname} {firstname}
    </h4>
  ), []);

  if (formType !== 'EDU') return title;

  const [formData, setFormData] = useState(dataForEduServices);
  const [isPending, setIsPending] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [inputs] = useState(siteRegInputs);

  const allFieldsFilled = Object.values(dataForEduServices).every(value => !!value);

  const changeInput = (inputName, val) => {
    const newFormData = Object.assign({}, formData);
    newFormData[inputName] = val;
    setFormData(newFormData);
  };

  const onSubmit = async () => {
    if(isPending) return;

    setErrorMessage('');

    setIsPending(true);
    const response = await updateUserData({studentData: formData, studentId});
    setIsPending(false);

    if (response.status === 'success') {
      window.location.assign('/profile?page=orders');
    } else if (response.status === 'error') {
      setErrorMessage(response.errors[0].message);
      throw new Error(response.errors[0].message);
    } else {
      setErrorMessage(messages.unknownError);
      throw new Error(messages.unknownError);
    }
  };

  useEffect(() => {
    if (formType === 'EDU') {
      if (allFieldsFilled) {
        metrikaGoal('fillAllLk');
      } else {
        metrikaGoal('fillSomeLk');
      }
    }
    setButtonDisabled(!allFieldsFilled, studentId);
  }, []);

  return (
    <>
      {title}
      {!allFieldsFilled && (
        studentData ? (
          <>
            <div className="inp-wrap">
              {inputs?.map(input =>
                prepareInput({
                  ...input,
                  value: formData[input.name],
                  onChangeCallback: changeInput,
                }),
              )}
              <Button
                onClick={onSubmit}
                extraClass='outline'
                className='inp btn btn--primary'
                isPending={isPending}
              >
                Сохранить
              </Button>
            </div>
            {errorMessage && (
              <React.Fragment>
                <FormMessage style={{marginTop: '40px'}} extraClass="error">
                  <p className="form-message__p">
                    {errorMessage}
                  </p>
                </FormMessage>
              </React.Fragment>
            )}
          </>
        ) : (
          <FormMessage style={{marginBottom: '40px'}} extraClass="error">
            Нет доступа к редактированию пользователя. Пожалуйста, обратитесь к менеджеру PwC
          </FormMessage>
        )
      )}
      {allFieldsFilled && !canPay && (
        <FormMessage style={{marginBottom: '40px'}} extraClass="warning">
          Оплата станет доступна, как только мы проверим предоставленные данные и оформим договор.
        </FormMessage>
      )}
    </>
  );
};
